/**
 * VIVA HUB Groups app — hub-wide RBAC and permissions
 */

import React from 'react'
import HubLayout from '../components/hub/HubLayout'
import HubGroupsSettings from '../components/hub/HubGroupsSettings'

export default function HubGroups() {
  return (
    <HubLayout appName="Groups">
      <p className="text-gray-600 mb-6">
        Manage the three VIVA HUB roles: Admin (full access), VIVA Associate (HUB, CRM, Room Scheduler, Profile, Email Signature), and Renter (HUB, Room Scheduler, Profile). Assign each user one role.
      </p>

      <HubGroupsSettings />
    </HubLayout>
  )
}
